import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

interface Props {
  baseUrl?: string;
  year: string;
}

export const ClientFooterKGM: React.FC<Props> = ({ baseUrl, year }) => {
  const [emailAddress, setEmailAddress] = useState<string>('');
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);

  useEffect(() => {
    const storedEmail = window.sessionStorage.getItem('userEmail');
    if (storedEmail) {
      setEmailAddress(storedEmail);
    }
  }, []);

  const errorMessageState = classNames({
    invalid_email: !isEmailValid,
    valid_email: isEmailValid,
  });

  const emailRegex = new RegExp(
    /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}/
  );

  const validateEmail = (email: string) => {
    return emailRegex.test(email);
  };

  const trySubmit = (e: React.MouseEvent<HTMLButtonElement>, email: string) => {
    e.preventDefault();
    const valid = validateEmail(email);
    setIsEmailValid(valid);

    if (valid) {
      window.sessionStorage.setItem('userEmail', email);
      window.location.href = '/subscribe';
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmailAddress(value);

    // Legacy behavior: validates on change
    setIsEmailValid(validateEmail(value));
  };

  return (
    <div>
      <section className="footer bg-concrete navigation-footer-mobile">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 footer_email_signup">
              <div className="text-center">
                <h4>Join the KGM family</h4>
                <p>
                  Fill in your email below and we will send the latest KGM
                  offers and news straight to your inbox
                </p>
              </div>
              <form className="form-inline">
                <div className="form-group">
                  <input
                    id="footer_email_input"
                    className="text"
                    placeholder="Enter your email address…"
                    type="email"
                    value={emailAddress}
                    onChange={handleEmailChange}
                  />
                  <div className={errorMessageState}>
                    Please provide a valid email address.
                  </div>
                </div>
                <div className="form-group text-center">
                  <button
                    className="btn btn-primary"
                    onClick={(e) => trySubmit(e, emailAddress)}
                  >
                    <span>Subscribe Now</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="text-center col-xs-12">
              <h5 className="text-uppercase">Get In Touch</h5>
              <p>Contact Us 1800 22 66 43</p>
            </div>
            <div className="col-xs-12 footer-social">
              <p className="text-center">
                <a
                  href="https://www.facebook.com/KGMaustralia"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="h4">
                    <span className="icon-stack">
                      <i className="icon icon-2x icon-circle-outline-medium" />
                      <i className="icon icon-1x icon-facebook text-primary" />
                    </span>
                  </span>
                </a>
                <a
                  href="https://www.youtube.com/user/KGMAustralia"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="h4">
                    <span className="icon-stack">
                      <i className="icon icon-2x icon-circle-outline-medium" />
                      <i className="icon icon-1x icon-youtube text-primary" />
                    </span>
                  </span>
                </a>
                <a
                  href="https://www.instagram.com/KGMaustralia/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="h4">
                    <span className="icon-stack">
                      <i className="icon icon-2x icon-circle-outline-medium" />
                      <i className="icon icon-1x icon-instagram text-primary" />
                    </span>
                  </span>
                </a>
              </p>
            </div>
            <div className="text-center col-xs-12">
              <p>
                &copy; {year === '' ? new Date().getFullYear() : year} - KGM
                (Aust) Pty Ltd
              </p>
            </div>
            <div className="text-center col-xs-12">
              <div className="footer-copyright-links">
                <span className="terms-conditions">
                  <a href={`${baseUrl}/terms`}>T&amp;C</a> |
                </span>
                <span className="terms-conditions">
                  <a href={`${baseUrl}/competition-terms`}>
                    Competition T&amp;C
                  </a>{' '}
                  |
                </span>
                <span className="privacy">
                  <a href={`${baseUrl}/privacy-policy`}>Privacy</a> |
                </span>
                <span className="customer-complaints-policy">
                  <a
                    href="https://docs.KGM.com.au/KGM_Website_Complaints_Policy_2025_FINAL.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Cust Complaints Policy
                  </a>{' '}
                  |
                </span>
                <span className="social-media-guidelines">
                  <a href={`${baseUrl}/social-media-guidelines`}>
                    Social Media
                  </a>{' '}
                  |
                </span>
                <span className="service-repair-info">
                  <a
                    href="https://www.right-2-repair.com.au/KGM"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Svc &amp; Rep Info
                  </a>
                </span>
                <span className="financial-services-terms">
                  <a href="/privacy-settings">Privacy Settings</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footer bg-concrete navigation-footer">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 footer_email_signup">
              <h4>Join the KGM family</h4>
              <p>
                Fill in your email below and we will send the latest KGM offers
                and news straight to your inbox
              </p>
              <form className="form-inline">
                <div className="form-group col-sm-4">
                  <input
                    id="footer_email_input"
                    className="text"
                    placeholder="Enter your email address…"
                    type="email"
                    value={emailAddress}
                    onChange={handleEmailChange}
                  />
                  <div className={errorMessageState}>
                    Please provide a valid email address.
                  </div>
                </div>
                <div className="col-sm-2">
                  <button
                    className="btn btn-primary"
                    onClick={(e) => trySubmit(e, emailAddress)}
                  >
                    <span>Subscribe Now</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-2">
              <h6 className="text-uppercase medium">Vehicles</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="/showroom">New Cars</a>
                </li>
                <li>
                  <a href="/hybrid">Hybrid</a>
                </li>
                <li>
                  <a href="/showroom/suvs">SUVs</a>
                </li>
                <li>
                  <a href="/showroom/sedans-and-hatchbacks">Sedans</a>
                </li>
                <li>
                  <a href="/showroom/sedans-and-hatchbacks">Hatchbacks</a>
                </li>
                <li>
                  <a href="/used">Used Cars</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-2">
              <h6 className="text-uppercase medium">Buyers tools</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="/showroom">Vehicle Pricing</a>
                </li>
                <li>
                  <a href="/special-offers">Special Offers</a>
                </li>
                <li>
                  <a href="/configure">Build Your Own</a>
                </li>
                <li>
                  <a href="/book-test-drive">Book A Test Drive</a>
                </li>
                <li>
                  <a href="/dealers">Find A Retailer</a>
                </li>
                <li>
                  <a href="/brochure-download">Request A Brochure </a>
                </li>
                <li>
                  <a href="/financial-services">Financial Services</a>
                </li>
                <li>
                  <a href="/premier-motor-insurance">Insurance</a>
                </li>
                <li>
                  <a href="/articles/car-advice">Car Advice</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-2">
              <h6 className="text-uppercase medium">Owners</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="/my-KGM">My KGM</a>
                </li>
                <li>
                  <a href="/owners/servicing">Service &amp; Maintenance</a>
                </li>
                <li>
                  <a href="/service-booking">Book a Service </a>
                </li>
                <li>
                  <a href="/parts">Genuine Parts</a>
                </li>
                <li>
                  <a href="/accessories-information">Accessories </a>
                </li>
                <li>
                  <a href="/owners/warranty">Warranty</a>
                </li>
                <li>
                  <a
                    href="/update-my-details"
                    id="change-ownership-updates-global-footer"
                  >
                    Change of Ownership
                  </a>
                </li>
                <li>
                  <a href="/fleet">Fleet</a>
                </li>
                <li>
                  <a href="/owners/collision-roadside">Roadside Assistance</a>
                </li>
                <li>
                  <a href="/servicing/KGM-map-update-program">
                    Satellite Nav Updates
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-sm-2">
              <h6 className="text-uppercase medium">Why KGM</h6>
              <ul className="list-unstyled">
                <li>
                  <a href="/why-KGM/history-and-motorsport">Our History</a>
                </li>
                <li>
                  <a href="/why-KGM/innovation">Innovation</a>
                </li>
                <li>
                  <a href="/safety">Safety</a>
                </li>
                <li>
                  <a href="/why-KGM/performance">Performance</a>
                </li>
                <li>
                  <a href="/why-KGM/technology">Technology</a>
                </li>
                <li>
                  <a href="/why-KGM/history-and-motorsport/timeline">Awards</a>
                </li>
                <li>
                  <a href="/news">News</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-4">
              <div className="row">
                <div className="col-sm-6">
                  <h6 className="text-uppercase medium">Visit The Shop</h6>
                  <ul className="list-unstyled">
                    <li>
                      <a href="/shop">Merchandise</a>
                    </li>
                    <li>
                      <a href="/accessories-information">Accessories</a>
                    </li>
                    <li>
                      <a href="/configure">Buy KGM Online</a>
                    </li>
                  </ul>
                </div>
                <div className="col-sm-6">
                  <h6 className="text-uppercase medium">Get In Touch</h6>
                  <ul className="list-unstyled">
                    <li>PO Box 8311, Baulkham Hills NSW 2153</li>
                    <li>
                      <a href="/contact-us">Contact Us</a>
                    </li>
                    <li>
                      <a href="/faqs">FAQs</a>
                    </li>
                  </ul>
                </div>
                <div className="col-xs-12 footer-social">
                  <p className="margin-top-4-xs text-right">
                    <a
                      href="https://www.facebook.com/KGMAustralia"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="h4">
                        <span className="icon-stack">
                          <i className="icon icon-2x icon-circle-outline-medium" />
                          <i className="icon icon-1x icon-facebook text-primary" />
                        </span>
                      </span>
                    </a>
                    <a
                      href="https://www.youtube.com/user/KGMAustralia"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="h4">
                        <span className="icon-stack">
                          <i className="icon icon-2x icon-circle-outline-medium" />
                          <i className="icon icon-1x icon-youtube text-primary" />
                        </span>
                      </span>
                    </a>
                    <a
                      href="https://www.instagram.com/KGMaustralia/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="h4">
                        <span className="icon-stack">
                          <i className="icon icon-2x icon-circle-outline-medium" />
                          <i className="icon icon-1x icon-instagram text-primary" />
                        </span>
                      </span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <hr className="footer-copyright-line" />
            </div>
            <div className="footer-copyright-container">
              <div className="col-sm-8 col-md-9 footer-copyright-links">
                <span className="terms-conditions">
                  <a href={`${baseUrl}/terms`}>Terms &amp; Conditions</a>
                </span>
                <span className="terms-conditions">
                  <a href={`${baseUrl}/competition-terms`}>
                    Competition Terms &amp; Conditions
                  </a>
                </span>
                <span className="privacy">
                  <a href={`${baseUrl}/privacy-policy`}>Privacy</a>
                </span>
                <span className="customer-complaints-policy">
                  <a
                    href="https://docs.KGM.com.au/KGM_Website_Complaints_Policy_2025_FINAL.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Customer Complaints Policy
                  </a>
                </span>
                <span className="social-media-guidelines">
                  <a href={`${baseUrl}/social-media-guidelines`}>
                    Social Media Guidelines
                  </a>
                </span>
                <span className="careers">
                  <a href={`${baseUrl}/careers`}>Careers</a>
                </span>
                <span className="careers">
                  <a href={`${baseUrl}/recall`}>Recalls</a>
                </span>
                <span className="careers">
                  <a href={`${baseUrl}/takata-recall`}>Takata Airbag Recall</a>
                </span>
                <span className="service-repair-info">
                  <a
                    href="https://www.right-2-repair.com.au/KGM"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Service &amp; Repair Info
                  </a>
                </span>
                <span className="financial-services-privacy">
                  <a href={`${baseUrl}/financial-services-privacy`}>
                    Financial Services Privacy
                  </a>
                </span>
                <span className="financial-services-terms">
                  <a href={`${baseUrl}/financial-services-terms`}>
                    Financial Services Terms of Use
                  </a>
                </span>
                <span className="financial-services-terms">
                  <a href="/privacy-settings">Privacy Settings</a>
                </span>
              </div>
              <div className="col-sm-4 col-md-3 footer-copyright-disclaimer">
                <div className="copyright-box-content">
                  &copy; {new Date().getFullYear()} - KGM (Aust) Pty Ltd
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
